var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-page" },
    [
      _c(
        "div",
        { staticClass: "data-page-header" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("performance-board::shopName") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        popperAppendToBody: false,
                        placeholder: _vm.$t(
                          "system::common::select_placeholder"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeShop()
                        },
                      },
                      model: {
                        value: _vm.selectedShop,
                        callback: function ($$v) {
                          _vm.selectedShop = $$v
                        },
                        expression: "selectedShop",
                      },
                    },
                    _vm._l(_vm.shopList, function (item) {
                      return _c("el-option", {
                        key: item.shopId,
                        attrs: { label: item.shopName, value: item.shopId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("performance-board::orderDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "260px" },
                    attrs: {
                      appendToBody: false,
                      clearable: false,
                      type: "daterange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "~",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.handlerDateChange },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("span", { staticClass: "header-tip" }, [
            _vm._v(_vm._s(_vm.$t("performance-board::data::tip"))),
          ]),
        ],
        1
      ),
      _vm.tabs === 1
        ? _c(
            "el-row",
            { staticClass: "card-content", attrs: { gutter: 20 } },
            _vm._l(_vm.cardOptions, function (item, index) {
              return _c(
                "el-col",
                {
                  key: index,
                  staticClass: "card-item",
                  attrs: { lg: 6, md: 6, sm: 6, xl: 6 },
                },
                [
                  _c("dataCard", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading.card,
                        expression: "loading.card",
                      },
                    ],
                    attrs: { option: item },
                  }),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.tabs === 1
        ? [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { lg: 12, md: 24, sm: 24, xl: 8 } },
                  [
                    _c("reportFunnel", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading.changeFunnel,
                          expression: "loading.changeFunnel",
                        },
                      ],
                      style: "height: " + _vm.reportHeight + ";",
                      attrs: { config: _vm.changeFunnel },
                      on: { change: _vm.changeFunnelType },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "row",
                            fn: function (ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                _c("div", { staticClass: "item" }, [
                                  _vm._v(_vm._s(item.action)),
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _vm._v(_vm._s(item.clientCnt)),
                                ]),
                                _c("div", { staticClass: "item" }),
                                _c("div", { staticClass: "item" }, [
                                  index !== 0
                                    ? _c("span", { staticClass: "info-rate" }, [
                                        item.transRateRatio &&
                                        item.transRateRatio < 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "rate",
                                                staticStyle: {
                                                  color: "#00ce47",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconic-xiajiang iconfont c-icon",
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "text" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            item.transRateRatio
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "symbol-end",
                                                      },
                                                      [_vm._v("%")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "rate t",
                                                staticStyle: {
                                                  color: "#ff0022",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconic-shangsheng iconfont c-icon",
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "text" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            item.transRateRatio
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "symbol-end",
                                                      },
                                                      [_vm._v("%")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ])
                                    : _vm._e(),
                                ]),
                                index !== 0
                                  ? _c("div", { staticClass: "after-item" }, [
                                      _vm._v(
                                        _vm._s(item.transRate || "0.00") + "%"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3251923356
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { lg: 12, md: 24, sm: 24, xl: 8 } },
                  [
                    _c("reportCard", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading.country,
                          expression: "loading.country",
                        },
                      ],
                      style: "height: " + _vm.reportHeight + ";",
                      attrs: { config: _vm.countryCharts },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { lg: 12, md: 24, sm: 24, xl: 8 } },
                  [
                    _c("reportCard", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading.utmCountry,
                          expression: "loading.utmCountry",
                        },
                      ],
                      style: "height: " + _vm.reportHeight + ";",
                      attrs: { config: _vm.utmCountryCharts },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { lg: 12, md: 24, sm: 24, xl: 8 } },
                  [
                    _c(
                      "reportTable",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading.utmSourceCharts,
                            expression: "loading.utmSourceCharts",
                          },
                        ],
                        style: "height: " + _vm.reportHeight + ";",
                        attrs: { config: _vm.utmSourceCharts },
                        on: { change: _vm.changeUtmType },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "utm",
                            label: _vm.$t("performance-board::data::来源"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sourceCnt",
                            label: _vm.$t("performance-board::data::用户数"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "utmPer",
                            label: _vm.$t("performance-board::data::占比"),
                            "min-width": "150px",
                            showOverflowTooltip: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "progress-flex" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "progress-wrap" },
                                          [
                                            _c("div", {
                                              staticClass: "progress-content",
                                              style: {
                                                width: row.utmPer + "%",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.utmPer)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1175362274
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { lg: 12, md: 24, sm: 24, xl: 8 } },
                  [
                    _c(
                      "reportTable",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading.areaSoure,
                            expression: "loading.areaSoure",
                          },
                        ],
                        style: "height: " + _vm.reportHeight + ";",
                        attrs: { config: _vm.areaSoureCharts },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "clientArea",
                            label: _vm.$t("performance-board::data::国家"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "clientCnt",
                            label: _vm.$t("performance-board::data::用户数"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "clientCntPer",
                            label: _vm.$t("performance-board::data::占比"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "progress-flex" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "progress-wrap" },
                                          [
                                            _c("div", {
                                              staticClass: "progress-content",
                                              style: {
                                                width: row.clientCntPer + "%",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.clientCntPer)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1180421090
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { lg: 12, md: 24, sm: 24, xl: 8 } },
                  [
                    _c(
                      "reportTable",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading.device,
                            expression: "loading.device",
                          },
                        ],
                        style: "height: " + _vm.reportHeight + ";",
                        attrs: { config: _vm.deviceCharts },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "deviceType",
                            label: _vm.$t("performance-board::data::设备"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "userNum",
                            label: _vm.$t("performance-board::data::用户数"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "percent",
                            label: _vm.$t("performance-board::data::占比"),
                            "min-width": "120px",
                            showOverflowTooltip: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "progress-flex" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "progress-wrap" },
                                          [
                                            _c("div", {
                                              staticClass: "progress-content",
                                              style: {
                                                width: row.percent + "%",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.percent)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            196990402
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
                  [
                    _c(
                      "reportTable",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading.visitorPage,
                            expression: "loading.visitorPage",
                          },
                        ],
                        style: "height: " + _vm.reportHeight + ";",
                        attrs: { config: _vm.visitorPageTable },
                        on: { "sort-change": _vm.sortChange },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "pageUrl",
                            label: _vm.$t(
                              "performance-board::data::pageVisitor_pageName"
                            ),
                            "min-width": "190px",
                            showOverflowTooltip: "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pageType",
                            label: _vm.$t(
                              "performance-board::data::pageVisitor_pageType"
                            ),
                            "min-width": "150px",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "visitCnt",
                            label: _vm.$t(
                              "performance-board::data::pageVisitor_visitorNum"
                            ),
                            sortable: "custom",
                            "min-width": "150px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm.$dataCheck(scope.row.visitCnt))
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            177435846
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "clientCnt",
                            label: _vm.$t(
                              "performance-board::data::pageVisitor_clientCnt"
                            ),
                            sortable: "custom",
                            "min-width": "150px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$dataCheck(scope.row.clientCnt)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            632147406
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "viewTimePer",
                            label: _vm.$t(
                              "performance-board::data::pageVisitor_visitorTime"
                            ),
                            sortable: "custom",
                            "min-width": "190px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$dataCheck(scope.row.viewTimePer)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3082073937
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "outRate",
                            label: _vm.$t(
                              "performance-board::data::pageVisitor_outRate"
                            ),
                            sortable: "custom",
                            "min-width": "150px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$dataCheck(scope.row.outRate)
                                      ) + "%"
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1160983884
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.isShowDetailDrawer,
            "show-close": false,
            size: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDetailDrawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "drawer-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v(_vm._s(_vm.$t("performance-board::goods_detail")))]
          ),
          _c(
            "el-scrollbar",
            [
              _c("detailDrawer", {
                attrs: {
                  id: _vm.spuId,
                  isShowDetailDrawer: _vm.isShowDetailDrawer,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }